import { getThemes, getThemeClass } from '@controllers/themeController';

export default function (widgetID, widgetOptions, buttonVisible) {
  const widgetName = widgetID;
  const widgetOpts = widgetOptions;
  const $widgetHTML = $(`#${widgetName}`);

  const themes = getThemes();
  function modifyEmailModule(emailSignup) {
    emailSignup.find('.emailSignupText').remove();
    emailSignup.find('label').css('display', 'block');
    const btnText = 'Sign up';
    emailSignup.find('.emailInputSubmit a').text(btnText);
  }

  function signupLayout(card) {
    const { class: fairTheme } = themes[1];
    const isFairTheme = getThemeClass() === fairTheme;

    if (isFairTheme) {
      const emailSignup = $('.seo-container-right .emailSignup');
      $(card).find('buttonwrap').remove();
      modifyEmailModule(emailSignup);
    }
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      const card = $(`#${widgetName} .card-widget-item`);
      if (card.length < 1) {
        $widgetHTML.remove();
      } else {
        signupLayout(card);
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: buttonVisible,
      text: 'Sign up',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
